<template>
	<div class="dashboard">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Export Member Rewards</h1>
		<div class="content-wrapper">
			<b-field label="Select Shop (Required)">
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="shopAutoComplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<div class="datepickerWrapper">
				<b-field label="Starting Date (Required)">
					<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="startingDate" icon="calendar-today">
						<button class="button is-primary" @click="startingDate = new Date()">
							<b-icon icon="calendar-today"></b-icon>
							<span>Today</span>
						</button>

						<button class="button is-danger" @click="startingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button></b-datepicker
					>
				</b-field>

				<b-field label="Ending Date (Required)">
					<b-datepicker
						:date-formatter="dateFormatter"
						placeholder="Click to select..."
						v-model="endingDate"
						icon="calendar-today"
						:min-date="minDate"
						:max-date="maxDate"
					>
						<button class="button is-danger" @click="endingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button></b-datepicker
					>
				</b-field>
			</div>

			<div class="filter-button-wrapper">
				<div class="big-button" @click="submit">SUBMIT</div>
			</div>
		</div>
	</div>
</template>

<script>
// import { bdBrands } from '@/data/brands.js'

export default {
	name: 'Dashboard',
	data: () => ({
		isLoading: false,
		totalSales: [],
		startingDate: null,
		endingDate: null,
		minDate: null,
		maxDate: null,
		shops: [], // For list of shops from API
		shopsSuggestions: '', // For dropdown selection
		selectedShop: null // Selected shop
	}),

	watch: {
		startingDate: function(data) {
			if (data !== null) {
				this.minDate = data
				this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.endingDate = data
			} else {
				this.endingDate = null
			}
		}
	},

	mounted: async function() {
		await this.getShops()
	},

	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		submit: async function() {
			if (this.selectedShop == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Shop is required'
				})

				return
			}

			if (this.startingDate == null || this.endingDate == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Starting and ending dates are required'
				})

				return
			}

			this.isLoading = true
			this.rewards = []

			this.totalSales = []
			this.totalSold = 0
			this.totalProfit = 0
			this.totalItems = 0
			this.totalOrders = 0

			var data = {}
			const createdAt = {}

			if (this.startingDate !== null) {
				createdAt['$gte'] = this.$moment(this.startingDate)
					.set({ hour: 0 })
					.format('x')
			}

			if (this.endingDate !== null) {
				createdAt['$lte'] = this.$moment(this.endingDate)
					.set({ hour: 24 })
					.format('x')
			}

			// For getting total value of sales
			data = {
				shop: this.selectedShop._id,
				limit: 5000,
				populate: ['member', 'shop', 'reward', 'product'],
				time: {
					createdAt
				}
			}

			const getRewards = await this.$api.getRewards({ data })

			if (getRewards.data.count < 1) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Data not found.'
				})
				this.isLoading = false
				return
			}

			let finalData = ''

			finalData += 'SHOP,REWARD,REWARD POINT,PRODUCT NAME,BD CODE,MEMBER ID,QUANTITY,DATE AND TIME\r\n'

			// total_products.map(p => {
			for (const rewardData in getRewards.data.list) {
				const reward = getRewards.data.list[rewardData]

				const shop = reward.shop
				const rewardDetail = reward.reward
				const member = reward.member
				const product = reward.product

				const toAdd = [
					shop.shop_id,
					rewardDetail.name,
					rewardDetail.points,
					'"' + product.name + '"',
					product.bd_code,
					member.card_number,
					1,
					this.convertTime(reward.createdAt)
				]

				let row = toAdd.join(',')

				finalData += row + '\r\n'
			}

			var csvData = new Blob([finalData], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', this.selectedShop.name + '_Export_Member_Rewards.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YYYY hh:mm A')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
